async function getFileFromUrl(url) {
  return new Promise((resolve, reject) => {
    window.resolveLocalFileSystemURL(
      url,
      (fileEntry) => {
        fileEntry.file((file) => {
          resolve(file)
        })
      },
      reject
    )
  })
}

function getBlobFromFileUrl(url) {
  return new Promise(async (resolve) => {
    let file = await getFileFromUrl(url)
    let reader = new FileReader()
    reader.onloadend = async (event) => {
      let blob = new Blob([event.target.result])
      resolve(blob)
    }
    reader.readAsArrayBuffer(file)
  })
}

export { getBlobFromFileUrl, getFileFromUrl }
